import { getCookieByName } from '~/utilities/data/getCookieByName';

/**
 * Retrieves the GDPR applicability status.
 *
 * This function checks if the `__tcfapi` object exists on the window. If it does not,
 * it attempts to retrieve a cookie named 'gdprApplies'. If the cookie is not found,
 * it defaults to returning '1'.
 *
 * @returns {string} The value of the 'gdprApplies' cookie, or '1' if the cookie is not found
 *                   and the `__tcfapi` object does not exist. If `__tcfapi` exists, it returns an empty string.
 */
export function getGdprApplies(): string {
  if (!window.__tcfapi) {
    return getCookieByName('gdprApplies') || '1';
  }
  return '';
}
